import { useCallback, useEffect } from "react";

import useService from "../../../../hooks/useService";
import { useEntityUsersStore } from "../store/entityUsersStore";

const normalizeUser = (item) => {
  console.log(item);
  return {
    id: item?.id ?? item?.pk,
    name: item?.name ?? "",
    email: item?.email ?? "",
    phone: item?.phone ?? "",
    role: item?.title ?? "",
    permissions: Array.isArray(item?.groupSetNames) ? item.groupSetNames : [],
  };
};

export default function useEntityUsersData(entityId) {
  const entityRepository = useService("repositories/entity-repository");
  const { currentPage, resLimit, setData, setLoading, setResultCount } = useEntityUsersStore();

  const fetchEntityUsersData = useCallback(async () => {
    if (!entityId) {
      return;
    }

    setLoading(true);
    try {
      const offset = (currentPage - 1) * resLimit;
      const response = await entityRepository.getRelatedUsers(entityId, {
        limit: resLimit,
        offset,
      });
      const results = Array.isArray(response) ? response : (response?.results ?? []);
      const count = Array.isArray(response)
        ? await entityRepository.getTotalCount()
        : response?.count;
      setData(results.map(normalizeUser));
      setResultCount(count || 0);
    } catch (error) {
      console.error("Error fetching related users:", error);
      setData([]);
      setResultCount(0);
    } finally {
      setLoading(false);
    }
  }, [currentPage, entityId, entityRepository, resLimit, setData, setLoading, setResultCount]);

  useEffect(() => {
    fetchEntityUsersData();
  }, [fetchEntityUsersData]);

  return { fetchEntityUsersData };
}
